import { IFromPrice, ISFCCFamilyPrice, ISFCCGroupPrice } from '@gn-audio/core/api/pricing/models';
import { ProductAttributeKey } from "@gn-audio/core/common/enums";
import { Component, Input, OnChanges } from 'angular-ts-decorators';

import template from './product-item-labels.component.html';

const metaRefurbishedAttribute = `${ProductAttributeKey.MetaRefurbished}|true`;
const metaDuscontinuedAttribute = `${ProductAttributeKey.MetaDuscontinued}|true`;
const specialOfferLabel = ProductAttributeKey.MetaSpecialOffer;

@Component({
  selector: 'productItemLabels',
  template,
})
export class ProductItemLabelsComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public attributes?: string[];
  @Input() public price?: IFromPrice | ISFCCFamilyPrice | ISFCCGroupPrice;
  @Input() public showSpecialOffer = false;

  public labels: string[] = [];

  public ngOnChanges() {
    this.labels = (this.attributes || [])
      .filter((a: string): boolean => {
        return a.toLowerCase() === metaDuscontinuedAttribute || a.toLowerCase() === metaRefurbishedAttribute;
      })
      .filter((label: string, index: number, context: string[]): boolean => context.indexOf(label) === index)
      .map((f: string): string => f.split('|')[0])
      .sort((f1: string, f2: string): number => {
        if (f1 > f2) {
          return 1;
        }

        if (f1 < f2) {
          return -1;
        }

        return 0;
      });

    if (this.labels.length === 0 && this.showSpecialOffer && this.price?.isDiscounted) {
      this.labels = [specialOfferLabel];
    }
  }
}
